export class PlanInterventionDTO {
    InterventionCode!: string;
    SamplerPuid!: string;
    Date!: string;
}